import React, { FunctionComponent } from "react"
import { Controller } from "react-hook-form"
import {
  accessList,
  exhibitionPlatforms,
  exhibitionTypes,
  EXHIBITION_TAG,
} from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Textarea from "../../../components/Form/Inputs/Textarea"
import AsyncCreatableTag from "../../../components/Form/Select/AsyncCreatableTag"
import SelectInput from "../../../components/Form/Select/Select"
import TextToSpeech from "../../../components/TextToSpeech/TextToSpeech"
import Upload from "../../../components/Upload/Upload"
import { iExhibition } from "../../../definitions/Exhibition"
import s from "./../Exhibitions.less"

interface iOverviewProps {
  item?: iExhibition
  onCreateAudio?: (data: any) => void
}

const ExhibitionOverview: FunctionComponent<iOverviewProps> = ({
  item = {} as iExhibition,
  onCreateAudio,
}) => {
  return (
    <div className="scrollable container">
      <div className="row">
        <div className="col-6">
          <FormInput name="title" label={"Title"} />
          <FormInput name="subtitle" label={"Subtitle"} />
          <Controller
            as={SelectInput}
            name="type"
            label="Exhibition type"
            value={exhibitionTypes.find((x) => x.value === item.type)}
            options={exhibitionTypes}
          />
          <Controller
            as={SelectInput}
            name="platforms"
            label="Platforms"
            isMulti={true}
            value={exhibitionPlatforms.find((x) => x.value === item.type)}
            options={exhibitionPlatforms}
          />
          <FormInput name="organizer" label="Organizer" />
          <FormInput name="timeframe" label="Timeframe" />
          <AsyncCreatableTag group={EXHIBITION_TAG} name="tags" label="Tags" />
          <Controller
            as={SelectInput}
            name="access"
            label="Exhibition status"
            value={accessList.find((x) => x.value === item.type)}
            options={accessList}
          />
        </div>
        <div className="col-6">
          <Controller as={Textarea} name="description" label="Description" />
          {item.description && !item.descriptionAudio && (
            <TextToSpeech
              text={item.description}
              onCreate={(data) => onCreateAudio && onCreateAudio(data)}
            />
          )}
          <Controller
            name="descriptionAudio"
            render={({ value }) => (
              <Upload
                name="descriptionAudio"
                fileCollection="Files_TextToSpeech"
                maxFiles={1}
                initialFiles={[value || ""]}
                label="Description Audio"
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}

export default ExhibitionOverview
